import Konva from 'konva/konva'
import ResizeHandle from './resize-handle'

export default class ResizeHandleLayer extends Konva.Layer {
  constructor ({ name }) {
    super({ name })
  }

  init ({ resizeHandleData }) {
    Object.assign(this, { resizeHandleData })

    this._render()
  }

  _render () {
    this.destroyChildren()

    this.resizeHandleData.reverse() // let a higher handle slide over lower ones
    this.resizeHandleData
      .forEach(({ yOffsetBottom, minDiff, resizeHandler }) =>
        this._renderResizeHandle(yOffsetBottom, minDiff, resizeHandler))

    this.draw()
  }

  _renderResizeHandle (yOffsetBottom, minDiff, resizeHandler) {
    this.add(new ResizeHandle({ yOffsetBottom, minDiff, resizeHandler }))
  }
}
